import { FormProvider, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { Stack, Button, Snackbar } from '@mui/joy';
import AddIcon from '@mui/icons-material/Add';
import { FormInput } from '@/components/forms/FormInput';
import { FormImage } from '@/components/forms/FormImage';
import { useCreateEventMutation, useUploadEventImageMutation } from '@/features/events/api';
import { eventSchema, newEvent } from '@/features/events/schema';
import { statusCodeToMessage } from '@/utils/errors';

export function AddEventForm({ householdId }) {
  const [createEvent, { isLoading }] = useCreateEventMutation();
  const form = useForm({
    defaultValues: newEvent(),
    resolver: yupResolver(eventSchema),
  });

  async function onSubmit(data) {
    const result = await createEvent({ householdId, data });
    if (result.error) {
      form.setError('root', { message: statusCodeToMessage(result.error.status) });
      return;
    }
    form.reset(newEvent());
  }

  const rootError = form.formState.errors.root;

  return (
    <FormProvider {...form}>
      <form onSubmit={form.handleSubmit(onSubmit)}>
        <Stack gap={2}>
          <FormInput name="name" label="Name" placeholder="e.g. Restaurant" />
          <FormImage name="image" label="Photo" useUploadImageMutation={useUploadEventImageMutation} />
          <Button type="submit" loading={isLoading} startDecorator={<AddIcon />} sx={{ alignSelf: 'flex-start' }}>
            Add Event
          </Button>
        </Stack>
      </form>
      <Snackbar
        color="danger"
        variant="soft"
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        open={!!rootError}
        onClose={() => form.clearErrors('root')}
      >
        {rootError?.message}
      </Snackbar>
    </FormProvider>
  );
}
